import { useEffect, useCallback, useRef } from "react";
import { Backdrop } from "@mui/material";
import { useLockedBody } from "usehooks-ts";
import { clsx } from "clsx";
import { ReactComponent as CloseIcon } from "components/icons/cross-black.svg";
import "./style/SwipePopup.scss";

interface ISwipePopupProps {
  onClose?: () => void;
  isOpen: boolean;
  children: React.ReactNode;
  title?: string;
  [x: string]: any;
}

export const SwipePopup = (props: ISwipePopupProps) => {
  const { onClose, isOpen, children, title, ...restProps } = props;
  const popupRef = useRef<HTMLInputElement>(null);

  const keyPress = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen && onClose) {
        onClose();
      }
    },
    [onClose, isOpen]
  );

  useLockedBody(isOpen, "root");

  useEffect(() => {
    document.body.classList.add("isPopup");

    return () => document.body.classList.remove("isPopup");
  }, [isOpen]);

  useEffect(() => {
    document.addEventListener("keydown", keyPress);

    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  const closePopup = (e: React.MouseEvent) => {
    if (popupRef.current === e.target && onClose) {
      onClose();
    }
  };

  const classes = clsx("SwipePopup", { "SwipePopup_isOpen": isOpen });

  return (
    <Backdrop
      open={isOpen}
      onClick={closePopup}
      ref={popupRef}
      sx={{
        zIndex: "var(--popupZ)"
      }}
      {...restProps}
    >
      <div className={classes}>
        <div className="SwipePopup-Header">
          <span>{title}</span>
          <button className="SwipePopup-Close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="SwipePopup-Cnt">{children}</div>
      </div>
    </Backdrop>
  );
};
